import { Input } from "@/components/ui/input"

export default function FormInputField({
  value,
  onChange,
  type,
  placeholder,
  icon: Icon,
  disabled,
}: {
  value: string
  onChange: (value: string) => void
  type: string
  placeholder: string
  icon: React.ComponentType<{ className?: string }> // Update type
  disabled?: boolean
}) {
  return (
    <div className="relative">
      {Icon && (
        <Icon className="absolute left-3 top-3 h-4 w-4 text-muted-foreground/60" />
      )}
      <Input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="pl-10 h-10 border-slate-200 dark:border-foreground/50 dark:focus-visible:ring-muted/50 rounded-sm text-sm focus:outline-none focus:border-slate-200 focus:ring-1 focus:border-1"
        required
        disabled={disabled}
      />
    </div>
  )
}
